<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter-number"><a id="page-21"></a><span href="#/toc#toc-chapter009" title="Link target outside of Sample">Chapter 9</span></h1>
<h1 class="chapter-title"><span href="#/toc#toc-chapter009" title="Link target outside of Sample">Pride Is Only the Self-Knowing of Great Men</span></h1>
<p class="noindent">He is the second greatest shaman who’s ever lived.</p>
<p>At least he thinks he’s the second greatest shaman who’s ever lived, but actually the matter is open to debate. He’s definitely in the top three, but it’s undecided as to whether he, or Blistering Steve, late of Streatham Common, is the true claimant to second place. The argument arises thus: did Blistering Steve succeed, in a moment of transcendent magical brilliance, in crossing the boundary between spirit and flesh and become, in a veritable flash of blinding light, a creature entirely of smoke and air; <em>or,</em> less impressively, did he merely contrive his own spontaneous combustion in an experiment gone tragically wrong? The evidence is vague either way, but as Blistering Steve’s rival to the title would point out, if his experiment had gone so well, surely he’d have been back, albeit in ethereal form, to let someone know?</p>
<p>Academic magicians are nothing if not prone to rivalries.</p>
<p>Laying all this aside, for now it is important to note the following:</p>
<p>Firstly, that the second–possibly third–greatest shaman who’s ever lived, has not today got his fix of peppermint super-strength toothpaste, and this has undeniably dented his mood.</p>
<p>Secondly, as he walks in that place between what <em>is</em> and what is merely <em>perceived to be,</em> with that special walk that only shamans know how to do, he looks down, sees something smoking beneath his feet, and is worried.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter009.vue?311ef8a0